export default function getCurrentRoute(props) {
  const { routes, route: currentRoute, params } = props;
  const paths = [];

  routes?.some((route) => {
    if (route.path) {
      paths.push(route.path);
    }
    return route === currentRoute;
  });

  const route = paths.map((path) => {
    if (path.startsWith(':')) return params[path.slice(1)];
    return path;
  }).join('/');

  return `/${route}`.replace(/\/{2,}/g, '/').replace(/\/$/g, '') || '';
}
